import type { ISiteApis } from '@wix/yoshi-flow-editor';
import { getSiteStructure } from './siteStructure';
import { PAGE_DATA } from 'root/appConsts/consts';
import { APP_DEF_IDS } from '@wix/restaurants-consts';
import type { ErrorMonitorUserData } from '@wix/panorama-client/dist/types/types';
import type { PanoramaErrorMonitor } from '@wix/panorama-client/dist/types/panorama-error-monitor';

const EDITOR_LIGHTBOX_TYPE = 'lightbox';
export const getPageOperationId = async (
  site: ISiteApis,
  errorMonitor?: PanoramaErrorMonitor<ErrorMonitorUserData>
): Promise<string | undefined> => {
  const siteStructure = await getSiteStructure(site);
  const { currentPage } = site;
  const oloPage = siteStructure.pages.find(
    (page) =>
      page.applicationId === APP_DEF_IDS.orders &&
      (page.id === currentPage?.id || currentPage?.type === EDITOR_LIGHTBOX_TYPE)
  );

  const operationId = oloPage?.tpaPageId.slice(PAGE_DATA.pageId.length + 1);

  if (!operationId && oloPage?.tpaPageId) {
    errorMonitor?.addBreadcrumb({
      category: 'get operationId from page',
      message: `Failed to get operationGroupId from page ${oloPage.tpaPageId}`,
    });
    errorMonitor?.reportError(
      new Error(`Failed to get operationGroupId from page ${oloPage.tpaPageId}`)
    );
  }
  return operationId;
};

export const getCurrentPageName = async (site: ISiteApis) => {
  const { currentPage } = site;
  return currentPage?.name;
};

export const getPageNameByOperationId = async (site: ISiteApis, operationId: string) => {
  const siteStructure = await getSiteStructure(site);
  return siteStructure.pages.find(
    (page) =>
      page.applicationId === APP_DEF_IDS.orders &&
      page.tpaPageId.slice(PAGE_DATA.pageId.length + 1) === operationId
  )?.name;
};

export const getPageNameByAppDefIdId = async (site: ISiteApis, appDefId: string) => {
  const siteStructure = await getSiteStructure(site);
  return siteStructure.pages.find((page) => page.applicationId === appDefId)?.name;
};
